/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerGetBatchQueryResponse, TransferBatchesControllerGetBatchPathParams, TransferBatchesControllerGetBatch400, TransferBatchesControllerGetBatch401, TransferBatchesControllerGetBatch403, TransferBatchesControllerGetBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerGetBatch";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferBatchesControllerGetBatch } from "../../clients/transfer-batchesService/transferBatchesControllerGetBatch";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferBatchesControllerGetBatchQueryKey = (id: TransferBatchesControllerGetBatchPathParams["id"]) => [{
  url: '/api/v1/transfer-batches/:id',
  params: {
    id: id
  }
}] as const;
export type TransferBatchesControllerGetBatchQueryKey = ReturnType<typeof transferBatchesControllerGetBatchQueryKey>;
export function transferBatchesControllerGetBatchQueryOptions(id: TransferBatchesControllerGetBatchPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferBatchesControllerGetBatchQueryKey(id);
  return queryOptions<TransferBatchesControllerGetBatchQueryResponse, ResponseErrorConfig<TransferBatchesControllerGetBatch400 | TransferBatchesControllerGetBatch401 | TransferBatchesControllerGetBatch403 | TransferBatchesControllerGetBatch404>, TransferBatchesControllerGetBatchQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferBatchesControllerGetBatch(id, config);
    }
  });
}

/**
 * @summary Get a transfer batch by ID
 * {@link /api/v1/transfer-batches/:id}
 */
export function useTransferBatchesControllerGetBatch<TData = TransferBatchesControllerGetBatchQueryResponse, TQueryData = TransferBatchesControllerGetBatchQueryResponse, TQueryKey extends QueryKey = TransferBatchesControllerGetBatchQueryKey>(id: TransferBatchesControllerGetBatchPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<TransferBatchesControllerGetBatchQueryResponse, ResponseErrorConfig<TransferBatchesControllerGetBatch400 | TransferBatchesControllerGetBatch401 | TransferBatchesControllerGetBatch403 | TransferBatchesControllerGetBatch404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferBatchesControllerGetBatchQueryKey(id);
  const query = useQuery({
    ...transferBatchesControllerGetBatchQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferBatchesControllerGetBatch400 | TransferBatchesControllerGetBatch401 | TransferBatchesControllerGetBatch403 | TransferBatchesControllerGetBatch404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}